export const CHANGE_SHOW_DIALOGS = "CHANGE_SHOW_DIALOGS";

export const CLEAR_STATE = "CLEAR_STATE";

export const SET_SEARCHED_ORGS = "SET_SEARCHED_ORGS";

export const GET_ORGANIZATION = "GET_ORGANIZATION";
export const GET_ORGANIZATION_SUCCESS = "GET_ORGANIZATION_SUCCESS";
export const GET_ORGANIZATION_FAIL = "GET_ORGANIZATION_FAIL";

export const GET_ALL_TENANTS = "GET_ALL_TENANTS";
export const GET_ALL_TENANTS_SUCCESS = "GET_ALL_TENANTS_SUCCESS";
export const GET_ALL_TENANTS_FAIL = "GET_ALL_TENANTS_FAIL";

export const ADD_ORGANIZATION = "ADD_ORGANIZATION";
export const ADD_ORGANIZATION_SUCCESS = "ADD_ORGANIZATION_SUCCESS";
export const ADD_ORGANIZATION_FAIL = "ADD_ORGANIZATION_FAIL";

export const ADD_TENANT = "ADD_TENANT";
export const ADD_TENANT_SUCCESS = "ADD_TENANT_SUCCESS";
export const ADD_TENANT_FAIL = "ADD_TENANT_FAIL";

export const MANUAL_CVRP_LAUNCH_MODE = "MANUAL_CVRP_LAUNCH_MODE";
export const MANUAL_CVRP_LAUNCH_MODE_SUCCESS = "MANUAL_CVRP_LAUNCH_MODE_SUCCESS";
export const MANUAL_CVRP_LAUNCH_MODE_FAIL = "MANUAL_CVRP_LAUNCH_MODE_FAIL";

export const EDIT_TENANT = "EDIT_TENANT";
export const EDIT_TENANT_SUCCESS = "EDIT_TENANT_SUCCESS";
export const EDIT_TENANT_FAIL = "EDIT_TENANT_FAIL";

export const EDIT_ORGANIZATION = "EDIT_ORGANIZATION";
export const EDIT_ORGANIZATION_SUCCESS = "EDIT_ORGANIZATION_SUCCESS";
export const EDIT_ORGANIZATION_FAIL = "EDIT_ORGANIZATION_FAIL";

export const CHANGE_TENANT_ACTIVATION = "CHANGE_TENANT_ACTIVATION";
export const CHANGE_TENANT_ACTIVATION_SUCCESS =
  "CHANGE_TENANT_ACTIVATION_SUCCESS";
export const CHANGE_TENANT_ACTIVATION_FAIL = "CHANGE_TENANT_ACTIVATION_FAIL";

export const GET_TENANT_BY_ID = "GET_TENANT_BY_ID";
export const GET_TENANT_BY_ID_SUCCESS = "GET_TENANT_BY_ID_SUCCESS";
export const GET_TENANT_BY_ID_FAIL = "GET_TENANT_BY_ID_FAIL";

export const DELETE_TENANT = "DELETE_TENANT";
export const DELETE_TENANT_SUCCESS = "DELETE_TENANT_SUCCESS";
export const DELETE_TENANT_FAIL = "DELETE_TENANT_FAIL";

export const GET_ORGANIZATION_BY_ID = "GET_ORGANIZATION_BY_ID";
export const GET_ORGANIZATION_BY_ID_SUCCESS = "GET_ORGANIZATION_BY_ID_SUCCESS";
export const GET_ORGANIZATION_BY_ID_FAIL = "GET_ORGANIZATION_BY_ID_FAIL";

export const CLONE_PLAN = "CLONE_PLAN";
export const CLONE_PLAN_SUCCESS = "CLONE_PLAN_SUCCESS";
export const CLONE_PLAN_FAIL = "CLONE_PLAN_FAIL";

export const GET_ORGANIZATION_USER = "GET_ORGANIZATION_USER";
export const GET_ORGANIZATION_USER_SUCCESS = "GET_ORGANIZATION_USER_SUCCESS";
export const GET_ORGANIZATION_USER_FAIL = "GET_ORGANIZATION_USER_FAIL";

export const GET_TENANT_USER = "GET_TENANT_USER";
export const GET_TENANT_USER_SUCCESS = "GET_TENANT_USER_SUCCESS";
export const GET_TENANT_USER_FAIL = "GET_TENANT_USER_FAIL";

export const CHANGE_ORGANIZATION_ACTIVATION = "CHANGE_ORGANIZATION_ACTIVATION";
export const CHANGE_ORGANIZATION_ACTIVATION_SUCCESS =
  "CHANGE_ORGANIZATION_ACTIVATION_SUCCESS";
export const CHANGE_ORGANIZATION_ACTIVATION_FAIL =
  "CHANGE_ORGANIZATION_ACTIVATION_FAIL";

export const UPDATE_ORGANIZATION_USER = "UPDATE_ORGANIZATION_USER";
export const UPDATE_ORGANIZATION_USER_SUCCESS =
  "UPDATE_ORGANIZATION_USER_SUCCESS";
export const UPDATE_ORGANIZATION_USER_FAIL = "UPDATE_ORGANIZATION_USER_FAIL";

export const UPDATE_TENANT_USER = "UPDATE_TENANT_USER";
export const UPDATE_TENANT_USER_SUCCESS = "UPDATE_TENANT_USER_SUCCESS";
export const UPDATE_TENANT_USER_FAIL = "UPDATE_TENANT_USER_FAIL";

export const CHANGE_ORG_PASSWORD = "CHANGE_ORG_PASSWORD";
export const CHANGE_ORG_PASSWORD_SUCCESS = "CHANGE_ORG_PASSWORD_SUCCESS";
export const CHANGE_ORG_PASSWORD_FAIL = "CHANGE_ORG_PASSWORD_FAIL";

export const TURNBACK_PLAN = "TURNBACK_PLAN";
export const TURNBACK_PLAN_SUCCESS = "TURNBACK_PLAN_SUCCESS";
export const TURNBACK_PLAN_FAIL = "TURNBACK_PLAN_FAIL";

export const CHANGE_TENANT_PASSWORD = "CHANGE_TENANT_PASSWORD";
export const CHANGE_TENANT_PASSWORD_SUCCESS = "CHANGE_TENANT_PASSWORD_SUCCESS";
export const CHANGE_TENANT_PASSWORD_FAIL = "CHANGE_TENANT_PASSWORD_FAIL";

export const GET_USER_TOKEN = "GET_USER_TOKEN";
export const GET_USER_TOKEN_SUCCESS = "GET_USER_TOKEN_SUCCESS";
export const GET_USER_TOKEN_FAIL = "GET_USER_TOKEN_FAIL";

export const GET_USER_TOKEN_BY_TENANT_ID = "GET_USER_TOKEN_BY_TENANT_ID";

export const GET_ORGANIZATION_USAGE = "GET_ORGANIZATION_USAGE";
export const GET_ORGANIZATION_USAGE_SUCCESS = "GET_ORGANIZATION_USAGE_SUCCESS";
export const GET_ORGANIZATION_USAGE_FAIL = "GET_ORGANIZATION_USAGE_FAIL";

export const GET_ORGANIZATIONS_USAGE = "GET_ORGANIZATIONS_USAGE";
export const GET_ORGANIZATIONS_USAGE_SUCCESS =
  "GET_ORGANIZATIONS_USAGE_SUCCESS";
export const GET_ORGANIZATIONS_USAGE_FAIL = "GET_ORGANIZATIONS_USAGE_FAIL";

export const DOWNLOAD_USAGE = "DOWNLOAD_USAGE";
export const DOWNLOAD_USAGE_SUCCESS = "DOWNLOAD_USAGE_SUCCESS";
export const DOWNLOAD_USAGE_FAIL = "DOWNLOAD_USAGE_FAIL";

export const GET_ORG_POC = "GET_ORG_POC";
export const GET_ORG_POC_SUCCESS = "GET_ORG_POC_SUCCESS";
export const GET_ORG_POC_FAIL = "GET_ORG_POC_FAIL";

export const UPDATE_ORG_POC = "UPDATE_ORG_POC";
export const UPDATE_ORG_POC_SUCCESS = "UPDATE_ORG_POC_SUCCESS";
export const UPDATE_ORG_POC_FAIL = "UPDATE_ORG_POC_FAIL";

export const ADD_ORG_POC = "ADD_ORG_POC";
export const ADD_ORG_POC_SUCCESS = "ADD_ORG_POC_SUCCESS";
export const ADD_ORG_POC_FAIL = "ADD_ORG_POC_FAIL";

export const REMOVE_ORG_POC = "REMOVE_ORG_POC";
export const REMOVE_ORG_POC_SUCCESS = "REMOVE_ORG_POC_SUCCESS";
export const REMOVE_ORG_POC_FAIL = "REMOVE_ORG_POC_FAIL";

export const GET_ORG_ADMINS = "GET_ORG_ADMINS";
export const GET_ORG_ADMINS_SUCCESS = "GET_ORG_ADMINS_SUCCESS";
export const GET_ORG_ADMINS_FAIL = "GET_ORG_ADMINS_FAIL";

export const ADD_ORG_ADMIN = "ADD_ORG_ADMIN";
export const ADD_ORG_ADMIN_SUCCESS = "ADD_ORG_ADMIN_SUCCESS";
export const ADD_ORG_ADMIN_FAIL = "ADD_ORG_ADMIN_FAIL";

export const GET_ALL_PLANS = "ADMIN_GET_ALL_PLANS";
export const GET_ALL_PLANS_SUCCESS = "ADMIN_GET_ALL_PLANS_SUCCESS";
export const GET_ALL_PLANS_FAIL = "ADMIN_GET_ALL_PLANS_FAIL";

export const SET_PLAN_STATUS = "ADMIN_SET_PLAN_STATUS";
export const SET_PLAN_STATUS_SUCCESS = "ADMIN_SET_PLAN_STATUS_SUCCESS";
export const SET_PLAN_STATUS_FAIL = "ADMIN_SET_PLAN_STATUS_FAIL";

export const RESTORE_PLAN = "RESTORE_PLAN_SUPERADMIN";
export const RESTORE_PLAN_FAIL = "RESTORE_PLAN_SUPERADMIN_FAIL";
export const RESTORE_PLAN_SUCCESS = "RESTORE_PLAN_SUPERADMIN_SUCCESS";

export const DOWNLOAD_EXCEL_FILE = "DOWNLOAD_EXCEL_FILE_SUPER_ADMIN";
export const DOWNLOAD_EXCEL_FILE_SUCCESS =
  "DOWNLOAD_EXCEL_FILE_SUPER_ADMIN_SUCCESS";
export const DOWNLOAD_EXCEL_FILE_FAIL = "DOWNLOAD_EXCEL_FILE_SUPER_ADMIN_FAIL";

export const SUPERADMIN_DOWNLOAD_OPTIMIZE_FILE =
  "SUPERADMIN_DOWNLOAD_OPTIMIZE_FILE";
export const SUPERADMIN_DOWNLOAD_OPTIMIZE_FILE_SUCCESS =
  "SUPERADMIN_DOWNLOAD_OPTIMIZE_FILE_SUCCESS";
export const SUPERADMIN_DOWNLOAD_OPTIMIZE_FILE_FAIL =
  "SUPERADMIN_DOWNLOAD_OPTIMIZE_FILE_FAIL";

export const GET_CUSTOM_SMS_LIST = "GET_CUSTOM_SMS_LIST_SUPER_ADMIN";
export const GET_CUSTOM_SMS_LIST_SUCCESS =
  "GET_CUSTOM_SMS_LIST_SUPER_ADMIN_SUCCESS";
export const GET_CUSTOM_SMS_LIST_FAIL = "GET_CUSTOM_SMS_LIST_SUPER_ADMIN_FAIL";

export const SET_CUSTOM_SMS_LIST = "SET_CUSTOM_SMS_LIST_SUPER_ADMIN";
export const SET_CUSTOM_SMS_LIST_SUCCESS =
  "SET_CUSTOM_SMS_LIST_SUPER_ADMIN_SUCCESS";
export const SET_CUSTOM_SMS_LIST_FAIL = "SET_CUSTOM_SMS_LIST_SUPER_ADMIN_FAIL";

export const GET_VERIFICATION_CODE_CONFIG = "GET_VERIFICATION_CODE_CONFIG";
export const GET_VERIFICATION_CODE_CONFIG_SUCCESS =
  "GET_VERIFICATION_CODE_CONFIG_SUCCESS";
export const GET_VERIFICATION_CODE_CONFIG_FAIL =
  "GET_VERIFICATION_CODE_CONFIG_FAIL";

export const SET_VERIFICATION_CODE_CONFIG = "SET_VERIFICATION_CODE_CONFIG";
export const SET_VERIFICATION_CODE_CONFIG_SUCCESS =
  "SET_VERIFICATION_CODE_CONFIG_SUCCESS";
export const SET_VERIFICATION_CODE_CONFIG_FAIL =
  "SET_VERIFICATION_CODE_CONFIG_FAIL";

export const GET_WEBHOOK_CONFIG = "GET_WEBHOOK_CONFIG";
export const GET_WEBHOOK_CONFIG_SUCCESS = "GET_WEBHOOK_CONFIG_SUCCESS";
export const GET_WEBHOOK_CONFIG_FAIL = "GET_WEBHOOK_CONFIG_FAIL";

export const SET_WEBHOOK_CONFIG = "SET_WEBHOOK_CONFIG";
export const SET_WEBHOOK_CONFIG_SUCCESS = "SET_WEBHOOK_CONFIG_SUCCESS";
export const SET_WEBHOOK_CONFIG_FAIL = "SET_WEBHOOK_CONFIG_FAIL";

export const GET_ALL_TENANT_USERS = "GET_ALL_TENANT_USERS";
export const GET_ALL_TENANT_USERS_SUCCESS = "GET_ALL_TENANT_USERS_SUCCESS";
export const GET_ALL_TENANT_USERS_FAIL = "GET_ALL_TENANT_USERS_FAIL";

export const GET_ALL_ORG_USERS = "GET_ALL_ORG_USERS";
export const GET_ALL_ORG_USERS_SUCCESS = "GET_ALL_ORG_USERS_SUCCESS";
export const GET_ALL_ORG_USERS_FAIL = "GET_ALL_ORG_USERS_FAIL";

export const GET_ROLE_FLAG = "GET_ROLE_FLAG";
export const GET_ROLE_FLAG_SUCCESS = "GET_ROLE_FLAG_SUCCESS";
export const GET_ROLE_FLAG_FAIL = "GET_ROLE_FLAG_FAIL";

export const GET_ORG_ROLE_FLAG = "GET_ORG_ROLE_FLAG";
export const GET_ORG_ROLE_FLAG_SUCCESS = "GET_ORG_ROLE_FLAG_SUCCESS";
export const GET_ORG_ROLE_FLAG_FAIL = "GET_ORG_ROLE_FLAG_FAIL";

export const GET_ORG_LIST_ID = "GET_ORG_LIST_ID";
export const GET_ORG_LIST_ID_SUCCESS = "GET_ORG_LIST_ID_SUCCESS";
export const GET_ORG_LIST_ID_FAIL = "GET_ORG_LIST_ID_FAIL";

export const CREATE_TENANT_USER = "CREATE_TENANT_USER";
export const CREATE_TENANT_USER_SUCCESS = "CREATE_TENANT_USER_SUCCESS";
export const CREATE_TENANT_USER_FAIL = "CREATE_TENANT_USER_FAIL";

export const CREATE_ORG_USER = "CREATE_ORG_USER";
export const CREATE_ORG_USER_SUCCESS = "CREATE_ORG_USER_SUCCESS";
export const CREATE_ORG_USER_FAIL = "CREATE_ORG_USER_FAIL";

export const CHANGE_USER_ACTIVATION = "CHANGE_USER_ACTIVATION";
export const CHANGE_USER_ACTIVATION_SUCCESS = "CHANGE_USER_ACTIVATION_SUCCESS";
export const CHANGE_USER_ACTIVATION_FAIL = "CHANGE_USER_ACTIVATION_FAIL";

export const GET_USER_BY_ID = "GET_USER_BY_ID";
export const GET_USER_BY_ID_SUCCESS = "GET_USER_BY_ID_SUCCESS";
export const GET_USER_BY_ID_FAIL = "GET_USER_BY_ID_FAIL";

export const GET_MISSION_REASON = "GET_MISSION_REASON";
export const GET_MISSION_REASON_SUCCESS = "GET_MISSION_REASON_SUCCESS";
export const GET_MISSION_REASON_FAIL = "GET_MISSION_REASON_FAIL";

export const ADD_MISSION_REASON = "ADD_MISSION_REASON";
export const ADD_MISSION_REASON_SUCCESS = "ADD_MISSION_REASON_SUCCESS";
export const ADD_MISSION_REASON_FAIL = "ADD_MISSION_REASON_FAIL";

export const UPDATE_MISSION_REASON = "UPDATE_MISSION_REASON";
export const UPDATE_MISSION_REASON_SUCCESS = "UPDATE_MISSION_REASON_SUCCESS";
export const UPDATE_MISSION_REASON_FAIL = "UPDATE_MISSION_REASON_FAIL";

export const DELETE_MISSION_REASON = "DELETE_MISSION_REASON";
export const DELETE_MISSION_REASON_SUCCESS = "DELETE_MISSION_REASON_SUCCESS";
export const DELETE_MISSION_REASON_FAIL = "DELETE_MISSION_REASON_FAIL";

export const CHANGE_USER_PASSWORD = "CHANGE_USER_PASSWORD";
export const CHANGE_USER_PASSWORD_SUCCESS = "CHANGE_USER_PASSWORD_SUCCESS";
export const CHANGE_USER_PASSWORD_FAIL = "CHANGE_USER_PASSWORD_FAIL";

export const Get_ROLE_ORGS = "Get_ROLE_ORGS";
export const Get_ROLE_ORGS_SUCCESS = "Get_ROLE_ORGS_SUCCESS";
export const Get_ROLE_ORGS_FAIL = "Get_ROLE_ORGS_FAIL";

export const ADD_ROLE = "ADD_ROLE";
export const ADD_ROLE_SUCCESS = "ADD_ROLE_SUCCESS";
export const ADD_ROLE_FAIL = "ADD_ROLE_FAIL";

export const GET_ALL_ROLES = "GET_ALL_ROLES";
export const GET_ALL_ROLES_SUCCESS = "GET_ALL_ROLES_SUCCESS";
export const GET_ALL_ROLES_FAIL = "GET_ALL_ROLES_FAIL";

export const GET_ROLE_BY_ID = "GET_ROLE_BY_ID";
export const GET_ROLE_BY_ID_SUCCESS = "GET_ROLE_BY_ID_SUCCESS";
export const GET_ROLE_BY_ID_FAIL = "GET_ROLE_BY_ID_FAIL";

export const GET_MENU = "GET_MENU";
export const GET_MENU_SUCCESS = "GET_MENU_SUCCESS";
export const GET_MENU_FAIL = "GET_MENU_FAIL";

export const GET_ACTION = "GET_ACTION";
export const GET_ACTION_SUCCESS = "GET_ACTION_SUCCESS";
export const GET_ACTION_FAIL = "GET_ACTION_FAIL";

export const ROLE_MODIFY_ACTIONS = "ROLE_MODIFY_ACTIONS";

export const DELETE_ROLE = "DELETE_ROLE";
export const DELETE_ROLE_SUCCESS = "DELETE_ROLE_SUCCESS";
export const DELETE_ROLE_FAIL = "DELETE_ROLE_FAIL";

export const EDIT_ROLE = "EDIT_ROLE";
export const EDIT_ROLE_SUCCESS = "EDIT_ROLE_SUCCESS";
export const EDIT_ROLE_FAIL = "EDIT_ROLE_FAIL";

export const GET_PLAN_LOGS_SUPERADMIN = "GET_PLAN_LOGS_SUPERADMIN";
export const GET_PLAN_LOGS_SUPERADMIN_SUCCESS =
  "GET_PLAN_LOGS_SUPERADMIN_SUCCESS";
export const GET_PLAN_LOGS_SUPERADMIN_FAIL = "GET_PLAN_LOGS_SUPERADMIN_FAIL";

export const GET_ALL_CONTRACTS = "GET_ALL_CONTRACTS";
export const GET_ALL_CONTRACTS_SUCCESS = "GET_ALL_CONTRACTS_SUCCESS";
export const GET_ALL_CONTRACTS_FAIL = "GET_ALL_CONTRACTS_FAIL";

export const ADD_CONTRACT = "ADD_CONTRACT";
export const ADD_CONTRACT_SUCCESS = "ADD_CONTRACT_SUCCESS";
export const ADD_CONTRACT_FAIL = "ADD_CONTRACT_FAIL";

export const DELETE_CONTRACT = "DELETE_CONTRACT";
export const DELETE_CONTRACT_SUCCESS = "DELETE_CONTRACT_SUCCESS";
export const DELETE_CONTRACT_FAIL = "DELETE_CONTRACT_FAIL";

export const EDIT_CONTRACT = "EDIT_CONTRACT";
export const EDIT_CONTRACT_SUCCESS = "EDIT_CONTRACT_SUCCESS";
export const EDIT_CONTRACT_FAIL = "EDIT_CONTRACT_FAIL";

export const REMOVE_REMINDER = "REMOVE_REMINDER";
export const REMOVE_REMINDER_SUCCESS = "REMOVE_REMINDER_SUCCESS";
export const REMOVE_REMINDER_FAIL = "REMOVE_REMINDER_FAIL";

export const REMOVE_ORG_ACCESS_BY_CONTRACT_END =
  "REMOVE_ORG_ACCESS_BY_CONTRACT_END";
export const REMOVE_ORG_ACCESS_BY_CONTRACT_END_SUCCESS =
  "REMOVE_ORG_ACCESS_BY_CONTRACT_END_SUCCESS";
export const REMOVE_ORG_ACCESS_BY_CONTRACT_END_FAIL =
  "REMOVE_ORG_ACCESS_BY_CONTRACT_END_FAIL";

export const GET_ACCOUNT_USAGE = "GET_ACCOUNT_USAGE";
export const GET_ACCOUNT_USAGE_SUCCESS = "GET_ACCOUNT_USAGE_SUCCESS";
export const GET_ACCOUNT_USAGE_FAIL = "GET_ACCOUNT_USAGE_FAIL";

export const CREATE_APP_VERSION = "CREATE_APP_VERSION";
export const CREATE_APP_VERSION_SUCCESS = "CREATE_APP_VERSION_SUCCESS";
export const CREATE_APP_VERSION_FAIL = "CREATE_APP_VERSION_FAIL";

export const GET_PLAN_FLOW_PROCESS = "GET_PLAN_FLOW_PROCESS";
export const GET_PLAN_FLOW_PROCESS_SUCCESS = "GET_PLAN_FLOW_PROCESS_SUCCESS";
export const GET_PLAN_FLOW_PROCESS_FAIL = "GET_PLAN_FLOW_PROCESS_FAIL";


export const GET_RABBIT_MQ_HEALTH = "GET_RABBIT_MQ_HEALTH";
export const GET_RABBIT_MQ_HEALTH_SUCCESS = "GET_RABBIT_MQ_HEALTH_SUCCESS";
export const GET_RABBIT_MQ_HEALTH_FAIL = "GET_RABBIT_MQ_HEALTH_FAIL";